import React from 'react';

import { ConfirmationLabel } from '../../shared-field-labels/shared-field-labels';
import { useFulfillmentDisplayContext } from '../display-context';
import ReadonlyField from './readonly-field';

const Confirmation = () => {
  const { confirmation } = useFulfillmentDisplayContext();

  return <ReadonlyField label={ConfirmationLabel}>{confirmation}</ReadonlyField>;
};
export default Confirmation;
